/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import './styles.scss'
import { DownloadBar } from '../downloadbar'
import { Spring, config } from 'react-spring/renderprops.cjs'
import { CompositeDisposable } from 'react-spring/web.cjs'

function convertSeconds(seconds) {
  let days = Math.floor(seconds / (3600 * 24))
  seconds -= days * 3600 * 24
  let hours = Math.floor(seconds / 3600)
  seconds -= hours * 3600
  let minutes = Math.floor(seconds / 60)
  seconds -= minutes * 60

  if (days.toString().length < 2) {
    days = '0' + days
  }
  if (hours.toString().length < 2) {
    hours = '0' + hours
  }
  if (minutes.toString().length < 2) {
    minutes = '0' + minutes
  }
  if (seconds.toString().length < 2) {
    seconds = '0' + seconds
  }

  let output = days > 0 ? days + ':' : ''
  output += hours > 0 ? hours + ':' : '00:'
  output += minutes > 0 ? minutes + ':' : '00:'
  output += seconds

  return output
}

export class DownloadComparison extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      downloadState: 'init',
      counterTime: 685420 // set this to seconds of the longest loadingbar
    }
    this.toggleDownload = this.toggleDownload.bind(this)
  }

  toggleDownload() {
    switch (this.state.downloadState) {
      case 'init':
        this.setState({ downloadState: 'running' })
        break
      case 'running':
        this.setState({ downloadState: 'completed' })
        break
      case 'completed':
        this.setState({ downloadState: 'running' })
        break
    }
  }

  render() {
    return (
      <div className='comparison-wrapper'>
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <div className='button-wrapper'>
          <div
            className={'ui icon button ' + this.state.downloadState}
            onClick={this.toggleDownload}
          >
            <i
              className={
                this.state.downloadState === 'init'
                  ? 'icon download'
                  : this.state.downloadState === 'running'
                  ? 'icon forward'
                  : this.state.downloadState === 'completed'
                  ? 'icon sync'
                  : ''
              }
            />{' '}
            {this.state.downloadState === 'init'
              ? 'Downloads simulieren'
              : this.state.downloadState === 'running'
              ? 'Downloads abschliessen'
              : this.state.downloadState === 'completed'
              ? 'Simulation neu starten'
              : 'Download'}
          </div>
        </div>
        <Spring
          from={{ number: 0 }}
          to={{
            number:
              this.state.downloadState === 'running'
                ? this.state.counterTime
                : 0
          }}
          config={{
            duration:
              this.state.downloadState === 'running'
                ? this.state.counterTime * 1000
                : 0
          }}
        >
          {props => (
            <div className={'counter ' + this.state.downloadState}>
              {this.state.downloadState === 'running'
                ? convertSeconds(Math.round(props.number))
                : ''}
            </div>
          )}
        </Spring>
        <DownloadBar
          year='2020'
          icon={require('../main/img/5g.svg')}
          mb={800}
          downloadrate={'3 Gbit/s'}
          seconds={2}
          downloadState={this.state.downloadState}
        />
        <DownloadBar
          year='2013'
          icon={require('../main/img/4g.svg')}
          mb={800}
          downloadrate={'150 Mbit/s'}
          seconds={43}
          downloadState={this.state.downloadState}
        />
        <DownloadBar
          year='2009'
          icon={require('../main/img/3g.svg')}
          mb={800}
          downloadrate={'42 Mbit/s'}
          seconds={152}
          downloadState={this.state.downloadState}
        />
        <DownloadBar
          year='2000'
          icon={require('../main/img/adsl.svg')}
          mb={800}
          downloadrate={'512 kbit/s'}
          seconds={12800}
          downloadState={this.state.downloadState}
        />
        <DownloadBar
          year='1998'
          icon={require('../main/img/isdn.svg')}
          mb={800}
          downloadrate={'128 kbit/s'}
          seconds={51200}
          downloadState={this.state.downloadState}
        />
        <DownloadBar
          year='1997'
          icon={require('../main/img/56k.svg')}
          mb={800}
          downloadrate={'56 kbit/s'}
          seconds={117029}
          downloadState={this.state.downloadState}
        />
        <div className='source'>Quelle: {this.props.source}</div>
      </div>
    )
  }
}
